import isEmpty from "lodash/isEmpty";
import uniq from "lodash/uniq";
import cloneDeep from "lodash/cloneDeep";
import WeaLocaleProvider from "../../wea-locale-provider";

const { getLabel } = WeaLocaleProvider;

export function getFilterData(datas) {
  let filterDatas = [];
  if (!isEmpty(datas) && datas.length) {
    datas.map(data => {
      if (!data) return;
      if (data.type === "resource") {
        filterDatas.push(data);
      } else if (data.users) {
        filterDatas = filterDatas.concat(data.users);
      }
    });
  }
  return filterDatas;
}

export function filterDatas(datas) {
  const { rightDatas } = this.state;
  let res = [];
  let ids = [];
  if (rightDatas) {
    rightDatas.forEach(d => {
      if (d.type == "resource") {
        ids.push(d.id);
      } else {
        d.users &&
          d.users.forEach(u => {
            ids.push(u.id);
          });
      }
    });
  }
  if (datas) {
    res = datas.filter(
      item => ids.indexOf(item.id) == -1 || item.type != "resource"
    );
  }
  return res;
}

export function formatData(datas) {
  let result = [];
  const { isShowGroup } = this.props;
  datas.forEach(item => {
    const caches = this.resourcesCache[item.type + item.id] || item;
    if (item.type === "resource") {
      result.push(item);
    } else {
      caches.users = item.users;
      if (isShowGroup) {
        if (caches.isPrivate == "true") {
          result = result.concat(this.formatData(caches.users));
        } else {
          result.push(caches);
        }
      } else {
        result = result.concat(this.formatData(caches.users));
      }
    }
  });
  return result;
}

export function getGroupTreeDatas(datas) {
  if (Array.isArray(datas)) {
    datas.map(this.getGroupTreeDatas);
  } else {
    datas.nocheck = true;
    datas.isParent =
      datas.isParent === "true" ||
      (datas.children != undefined && datas.children.length > 0);
    if (datas.isParent) {
      this.getGroupTreeDatas(datas.children);
    }
  }
}

export function refreshTreeDatas(datas, dataKey, childDatas) {
  const changeedDatas = datas.map(v => {
    if (v.key === dataKey) {
      return {
        ...v,
        childs: childDatas
      };
    } else {
      if (v.childs) {
        return {
          ...v,
          childs: this.refreshTreeDatas(v.childs, dataKey, childDatas)
        };
      }
      return v;
    }
  });
  return changeedDatas;
}

export function appendSearchValues(datas, needFilter = false) {
  const { selectedData } = this.state;
  let selectedDataB = cloneDeep(selectedData);
  if (needFilter) datas = this.filterDatas(datas);
  return this.setSearchValues(datas, selectedDataB);
}

export function replaceSearchValues(datas) {
  let selectedDataB = [];
  return this.setSearchValues(datas, selectedDataB, false);
}

export function setSearchValues(datas, selectedDataB, doChange = true) {
  const { maxLength } = this.props;
  if (datas && datas.length > 0) {
    for (let i = 0; i < datas.length; i++) {
      let data = datas[i];
      if (data) {
        data.type = data.type || "resource";
        data.lastname = data.lastname || data.name || "";
        if (data.type === "all") {
          // 所有人
          data.id = data.id || "all_x";
          data.nodeid = "all_x";
          selectedDataB = [data];
          break;
        } else if (data.type === "resource") {
          data.nodeid = `resource_${data.id}x`;
        } else {
          data.nodeid = `${data.type}_${data.id}x`;
        }
        if (
          selectedDataB &&
          !selectedDataB.some(d => d.nodeid == data.nodeid)
        ) {
          selectedDataB.push(data);
        }
      }
    }

    if (maxLength && maxLength < this.countCrm(selectedDataB, true)) {
      window.alert(
        getLabel(385619, "所选人数不能超出$s人!").replace(/\$s/, maxLength)
      );
      return;
    }
    doChange &&
      this.setState(
        {
          selectedData: selectedDataB
        },
        () => this.onChange(selectedDataB)
      );
  }
  return selectedDataB;
}

export function countCrm(datas, rNum = false) {
  let count = 0;
  let ids = [];
  datas.forEach(item => {
    if (item.type === "all") {
      count += item.count;
    } else if (item.type !== "resource") {
      count += (item.users || []).length;
    } else {
      ids.push(item.id);
    }
  });
  count += uniq(ids).length;
  if (rNum) return count;
  return count > 0 ? `(${count})` : "";
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/browser/formatData.js